import styles from "./styles.module.scss";
import { ReactComponent as OutlineUpload } from "assets/svg/outline-upload.svg";
import messages from "messages";
import type { CSSProperties, HTMLProps } from "react";

type Props = {
  storageDrive: StorageDrive;
  textStyle?: CSSProperties;
} & HTMLProps<HTMLDivElement>;
const DropZone = ({
  storageDrive,
  textStyle,
  className = "",
  onDrop,
  ...props
}: Props) =>
  storageDrive === "note-attachment" ? null : (
    <div
      className={styles["drop-zone"] + " " + className}
      // !! need this onDragOver to make onDrop work
      onDragOver={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      {...props}
      onDrop={(e) => {
        e.preventDefault();
        e.stopPropagation();
        return onDrop && onDrop(e);
      }}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className={styles["drop-zone__container"]}>
        <div style={textStyle}>
          <OutlineUpload />
          <div className={styles["drop-zone__text"]}>{messages.dropHere}</div>
        </div>
      </div>
    </div>
  );

export default DropZone;
